// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchInput {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px;
  background: #393a3b;
  border-radius: 4px;
  height: 36px;
}
.SearchInput .SearchInput-icon {
  color: #9ba1ad;
  color: var(--color_neutral_500, #9ba1ad);
  flex-shrink: 0;
}
.SearchInput .SearchInput-input {
  flex: 1 1;
  background: transparent;
  border: none;
  outline: none;
  color: #9ba1ad;
  color: var(--color_neutral_500, #9ba1ad);
  font-family: "Mulish", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
}
.SearchInput .SearchInput-input::placeholder {
  color: #9ba1ad;
  color: var(--color_neutral_500, #9ba1ad);
}
.SearchInput .SearchInput-input:focus {
  color: #ffffff;
  color: var(--color_neutral_0, #ffffff);
}
.SearchInput .SearchInput-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.SearchInput:has(input:disabled) {
  opacity: 0.6;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/search-input/search-input.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AACF;AACE;EACE,cAAA;EAAA,wCAAA;EACA,cAAA;AACJ;AAEE;EACE,SAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EAAA,wCAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAAJ;AAEI;EACE,cAAA;EAAA,wCAAA;AAAN;AAGI;EACE,cAAA;EAAA,sCAAA;AADN;AAII;EACE,YAAA;EACA,mBAAA;AAFN;AAME;EACE,YAAA;EACA,mBAAA;AAJJ","sourcesContent":[".SearchInput {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px;\n  background: #393a3b; // we don't have a variable for this color yet\n  border-radius: 4px;\n  height: 36px;\n\n  .SearchInput-icon {\n    color: var(--color_neutral_500, #9ba1ad);\n    flex-shrink: 0;\n  }\n\n  .SearchInput-input {\n    flex: 1;\n    background: transparent;\n    border: none;\n    outline: none;\n    color: var(--color_neutral_500, #9ba1ad);\n    font-family: 'Mulish', sans-serif;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 1.5;\n\n    &::placeholder {\n      color: var(--color_neutral_500, #9ba1ad);\n    }\n\n    &:focus {\n      color: var(--color_neutral_0, #ffffff);\n    }\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n    }\n  }\n\n  &:has(input:disabled) {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
